import request from '@/libs/request';

export const GetExaminationPaperList = (data = {}) => request('GetExaminationPaperList', data); // 查看考卷列表
export const GetExaminationPaperById = (data = {}) => request('GetExaminationPaperById', data); // 查看考卷详情
export const CreateExaminationPaper = (data = {}) => request('CreateExaminationPaper', data); // 创建考卷
export const UpdateExaminationPaper = (data = {}) => request('UpdateExaminationPaper', data); // 编辑考卷: 未发布的考卷才允许编辑
export const RemoveExaminationPaper = (data = {}) => request('RemoveExaminationPaper', data); // 删除考卷: 未发布的考卷才允许删除
export const PublishExaminationPaper = (data = {}) => request('PublishExaminationPaper', data); // 发布考卷
export const GetExaminationStatistic = (data = {}) => request('GetExaminationStatistic', data); // 考卷统计-人员统计, 题目统计(针对已经发布的考卷)
export const ExportExaminationStatistic = (data = {}) =>
  request('ExportExaminationStatistic', data); // 导出考卷统计
export const GetQuestionDetailById = (data = {}) => request('GetQuestionDetailById', data); // 查看题目，用于前端回显
export const GetQuestionList = (data = {}) => request('GetQuestionList', data); // 返回所有可见的问题
